(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leo-ambassadors"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.leoAmbBound) return;
    window.leoAmbBound = true;

    function openDialog(d) {
      if (!d || typeof d.showModal !== 'function' || d.open) return;
      d.showModal();
      document.documentElement.classList.add('leo-dialog-open');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-leo-amb-open]')) {
        openDialog(document.querySelector('[data-leo-amb-dialog]'));
        return;
      }
      var closer = e.target.closest('[data-leo-amb-close]');
      if (closer) {
        var d = closer.closest('dialog');
        if (d) d.close();
        return;
      }
      if (e.target.matches && e.target.matches('[data-leo-amb-dialog]')) e.target.close();
    });

    document.addEventListener('close', function (e) {
      if (e.target.matches && e.target.matches('[data-leo-amb-dialog]')) {
        document.documentElement.classList.remove('leo-dialog-open');
      }
    }, true);

    /* After sending: reopen the popup with the thank-you (or the error), only if THIS form was sent */
    function init() {
      document.querySelectorAll('[data-leo-amb]').forEach(function (root) {
        var form = root.querySelector('form');
        var ok = root.querySelector('[data-leo-amb-ok]');
        var fields = root.querySelector('[data-leo-amb-fields]');
        var serverErr = root.querySelector('[data-leo-amb-server-err]');
        var mine = form && window.location.hash === '#' + form.id;
        if (mine && ok) { ok.hidden = false; if (fields) fields.hidden = true; }
        if (!mine && serverErr) serverErr.hidden = true;
        if (mine && (ok || serverErr)) openDialog(root.closest('dialog'));
      });
    }

    /* Check the form, pack the multi-picks, and handle the early-access opt-in */
    document.addEventListener('submit', function (e) {
      var root = e.target.closest && e.target.closest('[data-leo-amb]');
      if (!root) return;
      var form = e.target;
      var err = root.querySelector('[data-leo-amb-err]');

      var hasHandle = Array.prototype.some.call(root.querySelectorAll('[data-leo-amb-handle]'), function (i) {
        return i.value.trim() !== '';
      });
      if (!hasHandle) {
        e.preventDefault();
        e.stopPropagation();
        if (err) { err.textContent = 'Add at least one place people can find you: Instagram, TikTok or a link.'; err.hidden = false; }
        var first = root.querySelector('[data-leo-amb-handle]');
        if (first) first.focus();
        return;
      }
      if (err) err.hidden = true;

      ['activities', 'content'].forEach(function (group) {
        var picked = [];
        root.querySelectorAll('[data-leo-amb-pick="' + group + '"]:checked').forEach(function (c) { picked.push(c.value); });
        var hidden = root.querySelector('[data-leo-amb-join="' + group + '"]');
        if (hidden) hidden.value = picked.join(', ');
      });

      var optin = root.querySelector('[data-leo-amb-optin]');
      if (optin && optin.checked && !root.dataset.optinSent) {
        root.dataset.optinSent = '1';
        var email = form.querySelector('[name="contact[email]"]');
        var params = new URLSearchParams();
        params.set('form_type', 'customer');
        params.set('utf8', '\u2713');
        params.set('contact[email]', email ? email.value.trim() : '');
        params.set('contact[tags]', 'early-access,creator-applicant');
        try {
          fetch('/contact', {
            method: 'POST',
            body: params,
            credentials: 'same-origin',
            keepalive: true,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          });
        } catch (x) {}
      }
    }, true);

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leo-clean-truths"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pick(root) {
      var sets = root.querySelectorAll('[data-leo-set]');
      var n = sets.length;
      if (!n) return;
      var idx = 0;
      var forced = root.getAttribute('data-leo-preview');
      if (forced !== null && forced !== '') {
        idx = parseInt(forced, 10) || 0;
      } else {
        try {
          var current = sessionStorage.getItem('leoTruthsShown');
          if (current === null) {
            var next = parseInt(localStorage.getItem('leoTruthsSet'), 10);
            if (isNaN(next) || next < 0 || next >= n) next = 0;
            idx = next;
            sessionStorage.setItem('leoTruthsShown', String(idx));
            localStorage.setItem('leoTruthsSet', String((idx + 1) % n));
          } else {
            idx = parseInt(current, 10);
            if (isNaN(idx) || idx < 0 || idx >= n) idx = 0;
          }
        } catch (e) {
          idx = 0;
        }
      }
      if (idx >= n) idx = 0;
      sets.forEach(function (el, i) { el.hidden = i !== idx; });
    }
    function init() { document.querySelectorAll('[data-leo-truths]').forEach(pick); }
    init();
    document.addEventListener('shopify:section:load', init);

    /* One open at a time */
    if (window.leoTruthsToggleBound) return;
    window.leoTruthsToggleBound = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.addEventListener('toggle', function (e) {
      var row = e.target;
      if (!row.classList || !row.classList.contains('leo-truths__row') || !row.open) return;
      var root = row.closest('[data-leo-truths]');
      if (!root) return;
      root.querySelectorAll('.leo-truths__row[open]').forEach(function (other) {
        if (other !== row) other.open = false;
      });
      requestAnimationFrame(function () {
        var top = row.getBoundingClientRect().top;
        if (top < 70) window.scrollBy({ top: top - 90, behavior: reduce ? 'auto' : 'smooth' });
      });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leo-everyday-athletes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.leoEaToggleBound) return;
    window.leoEaToggleBound = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.addEventListener('toggle', function (e) {
      var row = e.target;
      if (!row.classList || !row.classList.contains('leo-ea__row') || !row.open) return;
      var root = row.closest('[data-leo-ea]');
      if (!root) return;
      root.querySelectorAll('.leo-ea__row[open]').forEach(function (other) {
        if (other !== row) other.open = false;
      });
      requestAnimationFrame(function () {
        var top = row.getBoundingClientRect().top;
        if (top < 70) window.scrollBy({ top: top - 90, behavior: reduce ? 'auto' : 'smooth' });
      });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leo-footer"]) return;
  try {
    
  (function () {
    if (window.leoFooterBound) return;
    window.leoFooterBound = true;

    function lock(on) { document.documentElement.classList.toggle('leo-dialog-open', on); }
    function openDialog(d) {
      if (!d || typeof d.showModal !== 'function' || d.open) return;
      d.showModal();
      lock(true);
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-leo-contact-open]');
      if (opener) {
        openDialog(document.getElementById(opener.getAttribute('aria-controls')));
        return;
      }
      var closer = e.target.closest('[data-leo-contact-close]');
      if (closer) {
        var d = closer.closest('dialog');
        if (d) d.close();
        return;
      }
      if (e.target.tagName === 'DIALOG' && e.target.classList.contains('leo-contact')) e.target.close();
    });

    document.addEventListener('close', function (e) {
      if (e.target.classList && e.target.classList.contains('leo-contact')) lock(false);
    }, true);

    function init() {
      document.querySelectorAll('dialog.leo-contact').forEach(function (d) {
                var f = d.querySelector('form');
        if (f && window.location.hash === '#' + f.id && d.querySelector('[data-leo-contact-status]')) openDialog(d);
      });
    }
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leo-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hero = document.querySelector('[data-leo-hero]');
    if (!hero) return;
    if (hero.getAttribute('data-leo-tone') !== 'dark') {
      document.documentElement.classList.add('leo-has-hero');
    }

    var openBtn = hero.querySelector('[data-leo-open]');
    var panel = hero.querySelector('[data-leo-capture]');
    function openPanel() {
      if (!panel) return;
      panel.hidden = false;
      if (openBtn) { openBtn.hidden = true; openBtn.setAttribute('aria-expanded', 'true'); }
      var input = panel.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 60);
    }
    if (openBtn) openBtn.addEventListener('click', openPanel);
    if (window.location.hash === '#LeoEmail-hero') openPanel();

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var shopMode = hero.getAttribute('data-leo-action') === 'shop';
    function goToShop() {
      var shop = document.getElementById('shop');
      if (!shop) return false;
            var target = window.innerWidth < 990 ? (shop.querySelector('[data-leo-bb]') || shop) : shop;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - (target === shop ? 0 : ((document.querySelector('.header-wrapper') || {}).offsetHeight || 0) + 16), behavior: reduce ? 'auto' : 'smooth' });
      return true;
    }
        if (shopMode && window.location.hash === '#shop') setTimeout(goToShop, 300);
    var shopLink = hero.querySelector('[data-leo-shop-link]');
    if (shopLink) {
      shopLink.addEventListener('click', function (e) {
        if (goToShop()) e.preventDefault();
      });
    }

    var pill = document.querySelector('[data-leo-pill]');
    if (!pill) return;
    var visible = new Set();

    function update() {
      var show = window.scrollY > hero.offsetHeight * 0.5 && visible.size === 0;
      pill.classList.toggle('is-visible', show);
      pill.setAttribute('aria-hidden', show ? 'false' : 'true');
      pill.tabIndex = show ? 0 : -1;
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target);
        });
        update();
      });
      document.querySelectorAll('.leo-email').forEach(function (el) { io.observe(el); });
      if (shopMode && document.getElementById('shop')) io.observe(document.getElementById('shop'));
    }

    pill.addEventListener('click', function () {
      if (shopMode && goToShop()) return;
      var targets = Array.prototype.filter.call(document.querySelectorAll('.leo-email'), function (el) { return el.offsetParent !== null; });
      var target = targets[targets.length - 1];
      var behavior = reduce ? 'auto' : 'smooth';
      if (target) {
        target.scrollIntoView({ behavior: behavior, block: 'center' });
        var input = target.querySelector('input[type="email"]');
        if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, reduce ? 0 : 500);
      } else {
        window.scrollTo({ top: 0, behavior: behavior });
        openPanel();
      }
    });

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leo-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.leoIngBound) return;
    window.leoIngBound = true;

    function init() {
      document.querySelectorAll('[data-leo-ing]').forEach(function (root) {
        var cap = root.querySelector('[data-leo-ing-capture]');
        var btn = root.querySelector('[data-leo-ing-open]');
        if (cap && btn && cap.querySelector('form') && window.location.hash === '#' + cap.querySelector('form').id) {
          cap.hidden = false;
          btn.hidden = true;
        }
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-leo-ing-open]');
      if (!btn) return;
      var root = btn.closest('[data-leo-ing]');
      var cap = root && root.querySelector('[data-leo-ing-capture]');
      if (!cap) return;
      cap.hidden = false;
      btn.hidden = true;
      btn.setAttribute('aria-expanded', 'true');
      var input = cap.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 60);
    });

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leo-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.leoPdpBound) return;
    window.leoPdpBound = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init() {
      document.querySelectorAll('[data-leo-pdp]').forEach(function (root) {
        if (root.getAttribute('data-bound')) return;
        root.setAttribute('data-bound', '1');

        /* Gallery dots follow the swipe */
        var track = root.querySelector('[data-leo-pdp-track]');
        var dots = root.querySelectorAll('.leo-pdp__dot');
        if (track && dots.length) {
          track.addEventListener('scroll', function () {
            var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
            dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
          }, { passive: true });
        }

        /* Sticky bar: shows once the buy box scrolls away, hides at the final call to action */
        var sticky = root.querySelector('[data-leo-pdp-sticky]');
        var buy = root.querySelector('[data-leo-pdp-buy]');
        var end = root.querySelector('[data-leo-pdp-end]');
        if (sticky && buy && 'IntersectionObserver' in window) {
          var buyVisible = true, endVisible = false, pastBuy = false;
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (en.target === buy) {
                buyVisible = en.isIntersecting;
                pastBuy = en.boundingClientRect.top < 0;
              } else {
                endVisible = en.isIntersecting;
              }
            });
            var on = !buyVisible && !endVisible && pastBuy;
            sticky.classList.toggle('is-on', on);
            sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
            var btn = sticky.querySelector('[data-leo-pdp-jump]');
            if (btn) btn.tabIndex = on ? 0 : -1;
          });
          io.observe(buy);
          if (end) io.observe(end);
        }
      });
    }

    document.addEventListener('click', function (e) {
      var jump = e.target.closest('[data-leo-pdp-jump]');
      if (!jump) return;
      var root = jump.closest('[data-leo-pdp]');
      var buy = root && root.querySelector('[data-leo-pdp-buy]');
      if (!buy) return;
      buy.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      var input = buy.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, reduce ? 0 : 450);
    });

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leo-science"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.leoSciBound) return;
    window.leoSciBound = true;

    var PAL = {
      gold: ['#E9D27A', '#F0DE96', '#E2C85F'],
      tan: ['#C9A67F', '#D8BC9A', '#B98F63']
    };
    PAL.mix = PAL.gold.concat(PAL.tan);
    var COUNT = 46;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fields = [];
    var active = [];
    var ticking = false;
    var io = null;

    function rand(a, b) { return a + Math.random() * (b - a); }
    function clamp(v) { return v < 0 ? 0 : (v > 1 ? 1 : v); }
    function ease(t) { return 1 - Math.pow(1 - t, 3); }

    function build(el) {
      var colors = PAL[el.getAttribute('data-leo-dots')] || PAL.gold;
      var dots = [];
      var frag = document.createDocumentFragment();
      for (var i = 0; i < COUNT; i++) {
        var size = rand(4, 10);
        var jx = rand(-12, 12);
        var jy = rand(-12, 12);
        var dot = document.createElement('span');
        dot.className = 'leo-sci__dot';
        dot.style.width = size.toFixed(1) + 'px';
        dot.style.height = size.toFixed(1) + 'px';
        dot.style.left = 'calc(78% + ' + (jx - size / 2).toFixed(1) + 'px)';
        dot.style.top = (62 + jy - size / 2).toFixed(1) + 'px';
        dot.style.background = colors[Math.floor(Math.random() * colors.length)];
        var angle = rand(0, Math.PI * 2);
        var dist = rand(70, 270);
        dots.push({
          el: dot,
          dx: Math.cos(angle) * dist,
          dy: Math.sin(angle) * dist,
          start: rand(0.08, 0.32),
          dur: rand(0.3, 0.6)
        });
        frag.appendChild(dot);
      }
      el.appendChild(frag);
      return { card: el.closest('.leo-sci__card') || el, dots: dots };
    }

    function render(f) {
      var r = f.card.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight || 1;
      var p = clamp((vh - r.top) / (vh + r.height));
      for (var i = 0; i < f.dots.length; i++) {
        var d = f.dots[i];
        var t = clamp((p - d.start) / d.dur);
        var e = ease(t);
        d.el.style.transform = 'translate3d(' + (d.dx * e).toFixed(1) + 'px,' + (d.dy * e).toFixed(1) + 'px,0)';
        d.el.style.opacity = t < 0.25 ? '1' : (1 - (t - 0.25) / 0.75).toFixed(3);
      }
    }

    function frame() {
      ticking = false;
      for (var i = 0; i < active.length; i++) render(active[i]);
    }
    function request() {
      if (!ticking && active.length) {
        ticking = true;
        requestAnimationFrame(frame);
      }
    }

    function findField(card) {
      for (var i = 0; i < fields.length; i++) if (fields[i].card === card) return fields[i];
      return null;
    }

    function init() {
      fields = fields.filter(function (f) { return f.card.isConnected; });
      active = active.filter(function (f) { return f.card.isConnected; });
      document.querySelectorAll('[data-leo-dots]').forEach(function (el) {
        if (el.getAttribute('data-leo-built')) return;
        el.setAttribute('data-leo-built', '1');
        var f = build(el);
        fields.push(f);
        if (reduce) return; /* reduced motion: dots stay still in their starting cluster */
        render(f);
        if ('IntersectionObserver' in window) {
          if (!io) {
            io = new IntersectionObserver(function (entries) {
              entries.forEach(function (en) {
                var match = findField(en.target);
                if (!match) return;
                var idx = active.indexOf(match);
                if (en.isIntersecting) {
                  if (idx === -1) active.push(match);
                  render(match);
                } else if (idx !== -1) {
                  active.splice(idx, 1);
                }
              });
            }, { rootMargin: '100px 0px' });
          }
          io.observe(f.card);
        } else {
          active.push(f);
        }
      });
    }

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leo-why"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.leoWhyBound) return;
    window.leoWhyBound = true;

    function flip(tile) {
      var on = tile.getAttribute('aria-pressed') !== 'true';
      tile.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    function openCapture(btn) {
      var root = btn.closest('[data-leo-why]');
      var cap = root && root.querySelector('[data-leo-why-capture]');
      if (!cap) return;
      cap.hidden = false;
      btn.hidden = true;
      btn.setAttribute('aria-expanded', 'true');
      var input = cap.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 60);
    }
    function init() {
      document.querySelectorAll('[data-leo-why]').forEach(function (root) {
        var cap = root.querySelector('[data-leo-why-capture]');
        var btn = root.querySelector('[data-leo-why-open]');
        if (cap && btn && cap.querySelector('form') && window.location.hash === '#' + cap.querySelector('form').id) {
          cap.hidden = false;
          btn.hidden = true;
        }
      });
    }

    document.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-leo-flip]');
      if (tile) { flip(tile); return; }
      var btn = e.target.closest('[data-leo-why-open]');
      if (btn) openCapture(btn);
    });
    document.addEventListener('keydown', function (e) {
      var tile = e.target.closest && e.target.closest('[data-leo-flip]');
      if (tile && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); flip(tile); }
    });

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
